import useOnce from './useOnce';

export default useOnce;
